import { h, Component } from 'preact';
import { IoMdShare } from 'react-icons/io';

export const Share = props => (
    <button name="share" onClick={ props.onClick } className="share controlBarButton vjs-control vjs-button">
        <IoMdShare/>
    </button>
);